import React from "react";
const ArrowRight = ({ color, style }) => {
    return (React.createElement("svg", { className: style, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M5 12H19", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M12 5.00008L19 12.0001L12 19.0001", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
};
export default ArrowRight;
